import { Button, Icon, Spinner, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export const ArchiveToggleButton = ({
  asIconButton,
  action,
  id,
  processing = false,
  className = '',
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClick = useCallback(
    () =>
      dispatch({
        type: 'AGENCY/TOGGLE_CLIENT_ARCHIVE',
        payload: { ids: [id], action },
      }),
    [],
  )

  return asIconButton ? (
    <Tooltip title={t(`agency::list.extra_actions.${action}`)}>
      {processing ? (
        <Spinner width={24} />
      ) : (
        <Button
          startIcon={
            <Icon
              name={action === 'archive' ? 'inbox-archive' : 'inbox-upload'}
            />
          }
          noLabel
          color={'Label-GU-Primary'}
          noHover
          size={'m'}
          className={className}
          onClick={handleClick}
        />
      )}
    </Tooltip>
  ) : (
    <Button
      size={'m'}
      color={'Interface-Seventh'}
      onClick={handleClick}
      variant={'link'}
      startIcon={
        <Icon
          color={'Interface-GU-Primary'}
          name={action === 'archive' ? 'inbox-archive' : 'inbox-upload'}
          size={'m'}
        />
      }
    >
      {t(`agency::list.extra_actions.${action}`)}
    </Button>
  )
}

ArchiveToggleButton.propTypes = {
  asIconButton: PropTypes.bool,
  action: PropTypes.string,
  id: PropTypes.number,
  login: PropTypes.string,
  icon: PropTypes.string,
  processing: PropTypes.bool,
  className: PropTypes.string,
  toggleTo: PropTypes.oneOf(['activate', 'archive']),
  checkboxHandleChange: PropTypes.func,
}
